import { Elm } from './Main.elm';

const app = Elm.Main.init({
  node: document.getElementsByTagName('main')[0],
  flags: { apiUrl: process.env.API_URL },
});
